<template>
  <div>
    <div class="d-flex gap-3">
      <TextField
        v-model="form.ach_first_name"
        name="ach_first_name"
        label="First Name"
        class="full-width mr-2"
        :validation-errors="v$.$errors"
      />
      <TextField
        v-model="form.ach_last_name"
        name="ach_last_name"
        label="Last Name"
        class="full-width"
        :validation-errors="v$.$errors"
      />
    </div>
    <SelectBox
      v-model="form.ach_account_type"
      name="Account Type"
      label="Account Type"
      :options="accountTypes"
      placeholder="Select Account Type"
      :validation-errors="v$.$errors"
      class="mb-2"
    />
    <div class="d-flex gap-3 mb-2">
      <TextField
        v-model="form.ach_routing_number"
        name="ach_routing_number"
        label="Routing Number"
        class="full-width mr-2"
        :validation-errors="v$.$errors"
      />
      <TextField
        v-model="form.ach_account_number"
        name="ach_account_number"
        label="Account Number"
        class="full-width"
        :validation-errors="v$.$errors"
      />
    </div>
    <div
      v-if="config && config.card_savable && !autoSaveCard"
      class="d-flex flex-column mb-3"
    >
      <label class="mb-0 ml-2" style="font-size: 1.1em">
        <input v-model="form.ach_save_payment_method" type="checkbox" />
        Save for future payments.
      </label>
      <span class="ml-2" style="font-size: 0.9em"
        >(Saving this payment method replaces any previously saved payment
        method on file.)</span
      >
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import SelectBox from "../components/SelectBox.vue";
import TextField from "../components/TextField.vue";
import usePaymentMethods from "./usePaymentMethods";

export default {
  components: {
    SelectBox,
    TextField
  },
  props: {
    form: { type: Object, default: null },
    autoSaveCard: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { paymentMethodsResponse } = usePaymentMethods();
    return {
      paymentMethodsResponse,
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      form: {
        ach_routing_number: { required, $autoDirty: true },
        ach_last_name: { required, $autoDirty: true },
        ach_account_type: { required, $autoDirty: true },
        ach_account_number: { required, $autoDirty: true }
      }
    };
  },
  data() {
    return {
      accountTypes: [
        { label: "Checking", value: "checking" },
        { label: "Savings", value: "savings" }
      ]
    };
  },
  computed: {
    config() {
      return this.paymentMethodsResponse.find(
        (method) => method.key === "gpi_ach"
      );
    }
  }
};
</script>
